module.exports = __webpack_public_path__ + "img/supply-flow-lg.20f045f2.svg";